module.exports = __webpack_public_path__ + "static/media/minus.8bc3a620.png";